//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { VueCropper } from 'vue-cropper';
export default {
  components: {
    VueCropper: VueCropper
  },
  data: function data() {
    return {
      visible: false,
      id: null,
      confirmLoading: false,
      options: {
        img: '/avatar2.jpg',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      previews: {}
    };
  },
  methods: {
    edit: function edit(id) {
      this.visible = true;
      this.id = id;
      /* 获取原始头像 */
    },
    close: function close() {
      this.id = null;
      this.visible = false;
    },
    cancelHandel: function cancelHandel() {
      this.close();
    },
    okHandel: function okHandel() {
      var vm = this;
      vm.confirmLoading = true;
      setTimeout(function () {
        vm.confirmLoading = false;
        vm.close();
        vm.$message.success('上传头像成功');
      }, 2000);
    },
    realTime: function realTime(data) {
      this.previews = data;
    }
  }
};